var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { class: ["sub-values", { inline: _vm.none }] }, [
        _c(
          "div",
          {
            staticClass: "sub-value clickable",
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.none ? _vm.typeLabel : "Möglich"))
            ]),
            _vm._v(" "),
            !_vm.none ? _c("div", [_vm._v(_vm._s(_vm.typeLabel))]) : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.startEligible && _vm.data.start
          ? _c(
              "div",
              {
                staticClass: "sub-value clickable",
                on: {
                  click: function($event) {
                    return _vm.$emit("click")
                  }
                }
              },
              [
                _c("div", { staticClass: "label" }, [_vm._v("Ab wann")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.start))])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.degreeEligible
          ? _c(
              "div",
              {
                staticClass: "sub-value clickable",
                on: {
                  click: function($event) {
                    return _vm.$emit("click")
                  }
                }
              },
              [
                _c("div", { staticClass: "label" }, [_vm._v("Ausmaß")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.degree))])
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }